import React, { useRef } from "react";
import { MdClose } from "react-icons/md";
import { IconButton, Typography } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Chips } from "primereact/chips";

function getTypeof() {
  return [
    "Input text",
    "Input text multiline",
    "Datetime",
    "Combobox",
    "Multiple select",
    // "Lable",
    // "Editor",
    // "File",
    "Link",
    "Datetime Between",
  ];
}

function getWidth() {
  return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
}

const FilterPlanConfig = (props) => {
  const { valueGeneral, valueFilter, index, onChange, onClickDelete } = props;
  const valueName = valueGeneral.map((item) => item.colunmName);
  
  const reflbl = useRef();

  return (
    <div className="row rowPlanConfig">
      <div className="col-md-3">
        <Autocomplete
          id="combo-box"
          // disableCloseOnSelect
          options={valueName ? valueName : []}
          size="small"
          style={{ width: "100%" }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              label="Tên Trường"
              variant="outlined"
            />
          )}
          renderOption={(option) => (
            <Typography noWrap style={{ fontSize: "13px" }}>
              {option}
            </Typography>
          )}
          onChange={(e, newValue) => onChange(newValue, index, "colunmName")}
          value={valueFilter.colunmName}
        />
      </div>
      <div className="col-md-3">
        <Autocomplete
          options={getTypeof()}
          size="small"
          getOptionLabel={(option) => option}
          style={{ width: "100%" }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              label="Kiểu dữ liệu"
              variant="outlined"
            />
          )}
          renderOption={(option) => (
            <Typography noWrap style={{ fontSize: "14px" }}>
              {option}
            </Typography>
          )}          
          disabled = {valueFilter.disabled}
          onChange={(e, newValue) => onChange(newValue, index, "colunmType")}
          value={valueFilter.colunmType}
        />
      </div>
      {valueFilter.colunmType &&
        (valueFilter.colunmType === "Combobox" ||
          valueFilter.colunmType === "Multiple select") && (
          <div className="col-md-3">
            <div className="chips-cus">
              <label ref={reflbl}> Dữ liệu</label>
              <Chips
                value={valueFilter.colunmData}
                disabled = {valueFilter.disabled}
                // disabled={props.value.disabled}
                onFocus={(e) => reflbl.current.classList.add("lbl-focus")}
                onBlur={(e) => reflbl.current.classList.remove("lbl-focus")}
                onChange={(e) =>
                  props.onChange(e.value, index, "colunmData")
                }
              ></Chips>
            </div>
          </div>
        )}
      <div className="col-md-3">
        <Autocomplete
          options={getWidth()}
          size="small"
          getOptionLabel={(option) => option}
          style={{ width: "100%" }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              label="Độ rộng"
              variant="outlined"
            />
          )}
          renderOption={(option) => (
            <Typography noWrap style={{ fontSize: "14px" }}>
              {option}
            </Typography>
          )}
          value={valueFilter.colunmWidth}
          onChange={(e, newValue) => onChange(newValue, index, "colunmWidth")}
        />
      </div>
      <div className="col-md-3">
        <TextField
          fullWidth
          id="outlined-name"
          label="Tên trường mới"
          margin="dense"
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(e) => onChange(e.target.value, index, "colunmNewName")}
          value={valueFilter.colunmNewName}
        />
      </div>
      <div className="btn-handle">
        {/* <IconButton
          // disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-up-config"
          // onClick={() => props.onClickUp(props.index)}
        >
          <MdArrowUpward />
        </IconButton> */}
        {/* <IconButton
          // disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-down-config"
          // onClick={() => props.onClickDown(props.index)}
        >
          <MdArrowDownward />
        </IconButton> */}
        <IconButton
          // disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-delete-config"
          onClick={() => onClickDelete(index)}
        >
          <MdClose />
        </IconButton>
      </div>
    </div>
  );
};

export default FilterPlanConfig;
